module.exports = __webpack_public_path__ + "img/face-serum-pack.51251eb7.jpg";